import { render, staticRenderFns } from "./LogDetailsBottomDrawerDialog.vue?vue&type=template&id=55980180&scoped=true"
import script from "./LogDetailsBottomDrawerDialog.vue?vue&type=script&lang=ts"
export * from "./LogDetailsBottomDrawerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55980180",
  null
  
)

export default component.exports